/**
 * カスタムセレクトドロップダウンの初期化
 */
const main = () => {
    if (document.querySelector(".c-forms-select") === null) return;

    document.querySelectorAll(".c-forms-select").forEach((root) => {
        // disabled状態はスキップ
        if (root.hasAttribute("data-disabled")) return;

        const trigger = root.querySelector(".c-forms-select__trigger");
        const label = root.querySelector(".c-forms-select__label");
        const nativeSelect = root.querySelector(".c-forms-select__native");
        const options = root.querySelectorAll(".c-forms-select__option");

        // トリガークリックで開閉
        trigger.addEventListener("click", () => {
            const isOpen = root.hasAttribute("data-open");
            // 他のセレクトを閉じる
            document
                .querySelectorAll(".c-forms-select[data-open]")
                .forEach((el) => {
                    if (el !== root) el.removeAttribute("data-open");
                });
            if (isOpen) {
                root.removeAttribute("data-open");
            } else {
                root.setAttribute("data-open", "");
                // 展開時に選択中のオプションへフォーカスを移動
                // focusSelected は後続で定義されるが、クロージャ経由で参照されるため問題なし
                requestAnimationFrame(() => focusSelected());
            }
        });

        // カスタムUIをnative selectの値に同期する
        const syncUI = () => {
            const value = nativeSelect.value;
            const matchOption = Array.from(options).find(
                (o) => o.getAttribute("data-value") === value,
            );

            if (matchOption) {
                label.textContent = matchOption.querySelector(
                    ".c-forms-select__option-text",
                ).textContent;
                options.forEach((o) => o.removeAttribute("data-selected"));
                matchOption.setAttribute("data-selected", "");
            }

            if (value === "") {
                root.setAttribute("data-no-value", "");
            } else {
                root.removeAttribute("data-no-value");
            }
        };

        // 外部からnative selectの値が変更された場合にUIを同期
        nativeSelect.addEventListener("change", () => {
            syncUI();
        });

        // オプション選択
        options.forEach((option) => {
            option.addEventListener("click", () => {
                const value = option.getAttribute("data-value");

                // hidden selectの値を更新してchangeイベントを発火
                nativeSelect.value = value;
                nativeSelect.dispatchEvent(
                    new Event("change", { bubbles: true }),
                );

                // ドロップダウンを閉じてトリガーにフォーカスを戻す
                root.removeAttribute("data-open");
                trigger.focus();
            });
        });

        // キーボードナビゲーション
        const optionList = Array.from(options);

        const getFocusedIndex = () =>
            optionList.indexOf(document.activeElement);

        // 選択中のオプション（なければ先頭）にフォーカスを移動
        const focusSelected = () => {
            const selectedIndex = optionList.findIndex((o) =>
                o.hasAttribute("data-selected"),
            );
            const target = selectedIndex !== -1 ? optionList[selectedIndex] : optionList[0];
            if (target) target.focus();
        };

        const moveFocus = (delta) => {
            const current = getFocusedIndex();
            let next;
            if (current === -1) {
                next = delta > 0 ? 0 : optionList.length - 1;
            } else {
                next = current + delta;
                if (next < 0) next = 0;
                if (next >= optionList.length) next = optionList.length - 1;
            }
            optionList[next].focus();
        };

        trigger.addEventListener("keydown", (e) => {
            const isOpen = root.hasAttribute("data-open");
            if (e.key === "ArrowDown" || e.key === "ArrowUp") {
                e.preventDefault();
                if (!isOpen) {
                    root.setAttribute("data-open", "");
                    focusSelected();
                } else {
                    moveFocus(e.key === "ArrowDown" ? 1 : -1);
                }
            } else if (e.key === "Escape" && isOpen) {
                root.removeAttribute("data-open");
            }
        });

        root.querySelector(".c-forms-select__dropdown").addEventListener("keydown", (e) => {
            if (e.key === "ArrowDown") {
                e.preventDefault();
                moveFocus(1);
            } else if (e.key === "ArrowUp") {
                e.preventDefault();
                moveFocus(-1);
            } else if (e.key === "Escape") {
                root.removeAttribute("data-open");
                trigger.focus();
            }
        });
    });

    // 外側クリックで閉じる
    document.addEventListener("click", (e) => {
        if (!e.target.closest(".c-forms-select")) {
            document
                .querySelectorAll(".c-forms-select[data-open]")
                .forEach((el) => {
                    el.removeAttribute("data-open");
                });
        }
    });
};

export default main;
